<template>
  <div v-if="historyRecord.id !== currentTimeSheet.id" class="time-sheet-history-record">
    <div class="summary">
      <div class="icon-container" @click="isOpen = !isOpen">
        <div class="icon">
          <font-awesome-icon icon="calendar-alt" />
        </div>
      </div>
      <div class="description" @click="isOpen = !isOpen">
        <div class="modified-comment">
          {{ $t('timeSheets.history.version', { num }) }} -
          {{ historyRecord.approverComment }}
        </div>
        <div class="modified-info">
          Modified by
          {{ historyRecord.createdBy | nameFromUserObject }} at
          {{ historyRecord.createdAt | formatDateTime }}
        </div>
      </div>
      <div class="actions-and-status">
        <div>
          <Status :status="historyRecord.status" object-type="time-sheet" />
        </div>
        <!--
          Keep for now. In case users request thiis feature 
          in the future
        <div>
          <TolButton
            :tooltip="$t('timeSheet.actions.saveAsPdf')"
            button-type="minor"
            icon-name="file-pdf"
            class="action-round m"
            @click="exportAsPdf()"
          />
        </div>

        -->
        <div @click="isOpen = !isOpen">
          <font-awesome-icon :icon="isOpen ? 'minus-square' : 'plus-square'" />
        </div>
      </div>
    </div>
    <div v-show="isOpen" class="details">
      <TimeSheetDetailsTable :time-sheet="historyRecord" :can-edit="false" />
    </div>
  </div>
</template>

<script>
import Status from '@/app/components/Status';
import TimeSheetDetailsTable from './TimeSheetDetailsTable';

export default {
  name: 'TimeSheetHistoryRecord',
  components: { Status, TimeSheetDetailsTable },
  props: {
    historyRecord: {
      type: Object,
      required: true
    },
    num: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    currentTimeSheet() {
      return this.$store.state.timeSheetsState.timeSheetDetailsState.currentTimeSheet;
    }
  },
  methods: {
    exportAsPdf() {
      alert('pdf not yet implemented');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.time-sheet-history-record {
  .summary {
    padding: 20px $details-padding;
    display: flex;
    justify-content: space-between;

    > * {
      flex: 0 1 auto;
    }

    .icon-container {
      padding-right: 20px;

      .icon {
        color: $primary-blue-2;
        background: $mid-blue;
        padding: 10px;
        line-height: 10px;
        font-size: 15px;
        border-radius: 50%;
      }
    }

    .description {
      flex: 1 1 100%;

      .modified-comment {
        font-weight: bold;
      }

      .modified-info {
        font-style: italic;
        color: $grey;
      }
    }

    .actions-and-status {
      white-space: nowrap;
      display: flex;
      align-items: center;

      > * {
        display: inline-block;
        padding: 0 20px;
      }
    }
  }

  .details {
    padding-bottom: $details-padding;
  }
}

@media print {
  .time-sheet-history-record {
    .summary {
      page-break-inside: avoid;
      padding: 8px 0 5px 0;
      &:not(:last-child) {
        border-bottom: 1px solid $row-border;
      }
      .icon-container {
        display: none;
      }

      .description {
        font-size: 11px;
      }

      .actions-and-status {
        > * {
          border: none;
        }

        svg {
          display: none;
        }
      }
    }
  }
}
</style>
